var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { class: _vm.ulClass },
    [
      _vm._l(_vm.items, function (item, index) {
        return [
          item[_vm.groupProperty]
            ? [
                _c("Group", {
                  key: `menu-${_vm.level}-group-${index}`,
                  attrs: {
                    group: item,
                    level: _vm.level + 1,
                    groupProperty: _vm.groupProperty,
                  },
                }),
              ]
            : [
                _c("Item", {
                  key: `menu-${_vm.level}-item-${index}`,
                  attrs: { item: item },
                }),
              ],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }